import React from "react";
import G2 from "@antv/g2";
import { Row, Col, Icon } from "antd";
import { equals } from "ramda";
import moment from "moment";
import styled from "styled-components";
import I18n from "../../i18n";
import GraphConst from "../../constants/graph";
import { calVisitGraph, calVisitTitle, calVisitLength } from "../../util/graph";
import store from "../../reducers/";
import DatePagination from "../bar/DatePagination";

const DATE = GraphConst.DATE;
const SESSIONS = GraphConst.SESSIONS;

class SessionsGraph extends React.Component {
    state = {
    	title: "",
    	sessionsView: { [SESSIONS.ALL]: true, [SESSIONS.APP]: false, [SESSIONS.HOTLINE]: false },
    	viewBy: DATE.YEAR,
    	all: 0,
    	app: 0,
    	hotline: 0,
    	appointments: [],
    	move: 0,
    }

    onToggleSessionView = (view) => {
    	const { sessionsView } = this.state;
    	let toggleAvailable = 0;
    	Object.keys(sessionsView).map((key) => {
    		if (sessionsView[key]) toggleAvailable += 1;
    	});
    	if (toggleAvailable === 1 && sessionsView[view]) return;
    	sessionsView[view] = !sessionsView[view];
    	this.setState({ sessionsView }, () => this.filterSessions(true));
    }

    changeViewBy = (viewBy) => {
    	this.setState({ viewBy }, () => this.calRenderChart());
    }

    filterSessions = (render = false) => {
    	this.chart.filter("section", val => {
    		const { sessionsView } = this.state;
    		if (sessionsView[val])
    			return val;
    	});
    	if (render)
    		this.chart.render();
    }

    onClickChart = (data) => {
    	const { viewBy } = this.state;
    	switch (viewBy) {
    	case DATE.YEAR:
    		this.setState({ viewBy: DATE.MONTH }, () => this.calRenderChart(data));
    		break;
    	case DATE.MONTH:
    		this.setState({ viewBy: DATE.WEEK }, () => this.calRenderChart(data));
    		break;
    	case DATE.WEEK:
    		this.setState({ viewBy: DATE.DAY }, () => this.calRenderChart(data));
    		break;
    	default:
    		break;
    	}
    }

    calRenderChart(data, move) {
    	const { appointments } = this.props;
    	const { viewBy } = this.state;
    	if (!move && this.state.move != 0) this.setState({ move: 0 });

    	const chartData = calVisitGraph({
    		viewBy,
    		appointments,
    		selected: data ? data.title : null,
    		move
    	});
    	this.setState({ title: calVisitTitle(chartData) });

    	this.chart.source(chartData);
    	this.chart.render();
    }

    componentWillReceiveProps(nextProps) {
    	const { appointments } = this.state;
    	if (!equals(appointments, nextProps.appointments)) {
    		this.setState({ appointments: nextProps.appointments }, () => this.initChart());
    	}
    }

    initChart = () => {
    	const { appointments } = this.state;
    	this.setState(calVisitLength(appointments));
    	if (!this.chart) {
    		this.chart = new G2.Chart({
    			container: "chart",
    			forceFit: true,
    			height: 380,
    		});
    		this.chart.on("plotclick", ev => this.onClickChart(this.chart.getTooltipItems({ x: ev.x, y: ev.y })[0]));
    		this.chart.tooltip({ crosshairs: { type: "line" } });
    		this.chart.legend(false);
    		this.chart.area().position("title*value").color("section");
    		this.chart.line().position("title*value").color("section").size(2);
    	}
    	this.filterSessions();
    	this.calRenderChart();
    	window.dispatchEvent(new Event("resize"));
    }

    componentDidMount() {
    	const { appointments } = this.props;
    	if (appointments && appointments.length > 0) {
    		this.setState({ appointments }, () => this.initChart());
    	} else {
    		this.setState({ appointments: [] }, () => this.initChart());
    	}
    }

    onClickMoveGraph(value) {
    	const { move } = this.state;
    	this.setState({ move: move + value }, () => {
    		this.calRenderChart(null, this.state.move);
    	});
    }

    render() {
    	const { organization: { organization: { color } } } = store.getState();
    	const { sessionsView, viewBy, title, all, app, hotline } = this.state;
    	return (
    		<div>
    			<div>
    				<Row gutter={16}>
    					<ColSession>
    						<SessionButton onClick={() => this.onToggleSessionView(SESSIONS.ALL)}
    							title={I18n.t("all_visits")} description={all} active={sessionsView[SESSIONS.ALL]} />
    					</ColSession>
    					<ColSession>
    						<SessionButton onClick={() => this.onToggleSessionView(SESSIONS.APP)}
    							title={I18n.t("in_app")} description={app} active={sessionsView[SESSIONS.APP]} />
    					</ColSession>
    					<ColSession>
    						<SessionButton onClick={() => this.onToggleSessionView(SESSIONS.HOTLINE)}
    							title={I18n.t("hotline")} description={hotline} active={sessionsView[SESSIONS.HOTLINE]} />
    					</ColSession>
    				</Row>
    			</div>
    			<div style={{ border: "1px solid #e8e8e8", borderRadius: 4 }}>
    				<Row style={{ padding: "30px 35px 20px 35px" }}>
    					<Col span={12}>
    						<div style={{ fontSize: 18 }}>{I18n.t("visit")}</div>
    						<DatePagination 
    							color={color} 
    							onClick={(direction)=>{this.onClickMoveGraph(direction);}} 
    							text={title} 
    						/>
    					</Col>
    					<Col span={12}>
    						<div style={{ float: "right" }}>
    							{[DATE.DAY, DATE.WEEK, DATE.MONTH, DATE.YEAR].map(key=>(
    								<DateButton key={key} onClick={() => this.changeViewBy(key)} active={viewBy == key}>
    									{key}
    								</DateButton>
    							))}
    						</div>
    					</Col>
    				</Row>
    				<div id="chart"></div>
    			</div>
    		</div>
    	);
    }
}

export default SessionsGraph;

const ColSession = styled(Col).attrs({ xs: 24, sm: 24, md: 6, lg: 4, xl: 3 }) ``;

const SessionButtonContainer = styled.div`
    border: ${ props => `2px solid ${props.active ? "#00c4b3" : "#e8e8e8"}`};
    border-radius: 4px;
    padding: 5px 15px 5px 15px;
    cursor: pointer;
    margin: 15px 0;
`;

const DateButton = styled.span`
    margin: 0 10px;
    padding: 5px 8px;
    border-radius: 4px;
    cursor: pointer;
    color: #4a4a4a;
    background-color: ${props => props.active ? "#b3ede8" : "transparent"}
`;
const SessionButton = ({ title, description, active, onClick }) => (
	<SessionButtonContainer active={active} onClick={onClick}>
		<div style={{ color: "#6a7088", fontSize: 14 }}>{title}</div>
		<div style={{ color: "#161616", fontSize: 24 }}>{description}</div>
	</SessionButtonContainer>
);


// WEBPACK FOOTER //
// ./src/components/home/SessionsGraph.js